import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { Logo } from "@/components/Logo";
import { api } from "@/lib/api";

export default function VerifyEmailSent() {
  const { state } = useLocation();
  const email = state?.email || "";
  const [busy, setBusy] = useState(false);

  const resend = async () => {
    if (!email) return;
    setBusy(true);
    try {
      await api.post("/auth/resend-verification", { email });
      toast.success("Verification email resent — check your inbox.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not resend. Try again shortly.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] px-6">
      <div className="w-full max-w-md text-center">
        <Logo size="md" />
        <div className="mt-12 flex justify-center">
          <div className="h-16 w-16 rounded-full bg-[#F3F1EC] flex items-center justify-center">
            <Mail className="h-7 w-7 text-[#C86B53]" />
          </div>
        </div>
        <h1 className="mt-6 text-3xl font-display font-semibold tracking-tight">Check your inbox</h1>
        <p className="mt-3 text-[#5C5F62]">
          We sent a verification link to{" "}
          {email ? <span className="font-medium text-[#1A1C1E]">{email}</span> : "your email"}.
          Click it to activate your account.
        </p>
        <p className="mt-6 text-sm text-[#8A8D91]">
          Didn't receive it?{" "}
          {email ? (
            <button
              onClick={resend}
              disabled={busy}
              className="text-[#C86B53] hover:underline disabled:opacity-50"
            >
              {busy ? "Sending…" : "Resend email"}
            </button>
          ) : (
            <Link to="/signup" className="text-[#C86B53] hover:underline">Sign up again</Link>
          )}
        </p>
        <Link to="/login" className="mt-8 block text-sm text-[#5C5F62] hover:text-[#1A1C1E]">
          Back to login
        </Link>
      </div>
    </div>
  );
}
